import { Component, OnInit, ChangeDetectorRef, ElementRef, Injectable, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReportService } from '../../services/report.service';
import { TutukaReportDTViewModel } from '../../models/tutuka-report-dt-view-model';
import { MerchantGroupReportDTViewModel } from '../../models/merchant-group-report-dt-view-model';
import { PermissionEnum } from '../../services/guards/permissions';
import { BankTransactionData } from '../../models/bank-transaction-data-view-model';
import { BankTransaction } from '../../models/bank-transaction-view-model';
import { BankTransactionTotal } from '../../models/bank-transaction-total-view-model';
import { BankTransactionReferenceTotal } from '../../models/bank-transaction-reference-view-model';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ExcelJson } from '../../models/Excel-Json-model';
import { MerchantReportDTViewModel } from '../../models/merchant-report-dt-view-model';
import { MerchantReportUserLinkDTViewModel } from '../../models/merchant-report-user-link-dt-view-model';
import { Reference } from '@angular/compiler/src/render3/r3_ast';


@Component({
  selector: 'app-tutuka-report-management',
  templateUrl: './tutuka-report-management.component.html',
  styleUrls: ['./tutuka-report-management.component.scss']
})
export class TutukaReportManagementComponent implements OnInit {

  @ViewChild('userTable') userTable: ElementRef;

  public raiseWarning: boolean;
  public raiseDanger: boolean;
  public hasData: boolean;
  public warning: string;
  public danger: string;
  public startDate: Date;
  public endDate: Date;

  public reportData: BankTransactionData;

  public bankTransactionData: BankTransaction[] = [];
  public bankTransactionTotal: BankTransactionTotal[] = [];
  public bankTransactionReferenceTotal: BankTransactionReferenceTotal[] = [];

  public totalRefrow: BankTransactionReferenceTotal;

  public merchants: MerchantReportUserLinkDTViewModel[];
  public selectedMerchant: string;
  public hasMultipleUSNNumbers: boolean;

  public edata: Array<ExcelJson> = [];

  public canView: boolean;
  public noData: string;
  public raiseNoData: boolean;
  public tableCreated: boolean;

  constructor(private _changeDetectorRef: ChangeDetectorRef,
    private _toastService: ToastrService,
    private _modalService: NgbModal,
    private _authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _reportService: ReportService,
    private _ngxLoader: NgxUiLoaderService) {

    this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTutukaReport]);
    if (!this.canView) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }
    this.hasData = false;



  }

  public async ngOnInit(): Promise<void> {

    var user = this._userDataStore.currentUserValue.id;
    this.merchants = await this._reportService.GetAllMerchantsReportsUserLinkByUser(user);

    if (this.merchants.length > 1) {
      this.hasMultipleUSNNumbers = true;
    }
    else {
      this.hasMultipleUSNNumbers = false;
    }
  }

  public async submit(): Promise<void> {
    if (this.startDate == undefined && this.endDate == undefined) {
      this.raiseDanger = true;
      this.danger = "Start and End date are required";
    }
    else if (this.startDate == undefined) {
      this.raiseDanger = true;
      this.danger = "Start date is required";
    }
    else if (this.endDate == undefined) {
      this.raiseDanger = true;
      this.danger = "End date is required";
    }
    else if (this.startDate > this.endDate) {
      this.raiseDanger = true;
      this.danger = "Start date cannot be greater than End date";
    }
    else {

      if (this.hasMultipleUSNNumbers) {
        if (this.selectedMerchant == undefined || this.selectedMerchant == "") {
          this.raiseDanger = true;
          this.danger = "Select a merchant number";
        }
        else {
          this.raiseDanger = false;
          this.danger = "";

          this._ngxUiLoaderService.start();

          this.reportData = await this._reportService.GetBankReportDataByMerchant(this.startDate, this.endDate, this.selectedMerchant);

          if (this.reportData == null || this.reportData == undefined) {
            this.noData = "No data available.";
            this.raiseNoData = true;
            return;
          }

          if (this.reportData.bankTransaction.length <= 0) {
            this.noData = "No data available.";
            this.raiseNoData = true;
          }
          else {
            this.noData = "";
            this.raiseNoData = false;

            this.bankTransactionData = this.reportData.bankTransaction;
            //this.bankTransactionTotal = this.reportData.bankTransactionTotal;
            this.bankTransactionReferenceTotal = this.reportData.bankTransactionReferenceTotal;

            if (this.bankTransactionData.length > 0) {
              this.hasData = true;
            } else {
              this.hasData = false;
            }

            //REFERENCE: https://javascript.plainenglish.io/creating-a-dynamic-html-table-through-javascript-f554fba376cf
            this.ClearTable();
            var count: number = 0;

            var prevTerminal = "";
            var prevDay = new Date(1900, 1, 1);
            var prevDayS = "";
            var rowDate = "";

            var tableName = "";
            for (const row of this.bankTransactionData) {

              count++;

              if (count == 1) {
                prevTerminal = row.terminalNumber;
                prevDay = row.batchDate;
              }


              var dd = String(prevDay.getDate()).padStart(2, '0');
              var mm = String(prevDay.getMonth() + 1).padStart(2, '0'); //January is 0!
              var yyyy = prevDay.getFullYear();
              prevDayS = mm + '/' + dd + '/' + yyyy;


              var dd_ = String(row.batchDate.getDate()).padStart(2, '0');
              var mm_ = String(row.batchDate.getMonth() + 1).padStart(2, '0'); //January is 0!
              var yyyy_ = row.batchDate.getFullYear();
              rowDate = mm_ + '/' + dd_ + '/' + yyyy_;


              if ((prevDayS == rowDate) && (prevTerminal == row.terminalNumber)) {
                //create table once since this terminal repeats.
                if (!this.tableCreated) {
                  tableName = "table" + count;
                  this.CreateBankTransactionDataTable(tableName);
                  this.tableCreated = true;
                }
                this.AppendBankTransactionData(row, tableName);
              }
              else {
                this.tableCreated = false;

                var totalReference = 0;
                for (var refRow of this.bankTransactionReferenceTotal) {

                  var dd = String(row.transactionTime.getDate()).padStart(2, '0');
                  var mm = String(row.transactionTime.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var yyyy = row.transactionTime.getFullYear();
                  let prevDay_ = mm + '/' + dd + '/' + yyyy;

                  var dd_ = String(refRow.transactionDate.getDate()).padStart(2, '0');
                  var mm_ = String(refRow.transactionDate.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var yyyy_ = refRow.transactionDate.getFullYear();
                  let rowDate_ = mm_ + '/' + dd_ + '/' + yyyy_;


                  if (rowDate_ >= prevDayS && rowDate_ < prevDay_) {
                    if (!this.tableCreated) {
                      tableName = "tableRef" + count;
                      this.CreateReferenceTotalTable(tableName);
                      this.tableCreated = true;
                    }
                    this.AppendBankReferenceData(refRow, tableName);
                    totalReference += refRow.total;
                  }
                }
                if (totalReference != 0) {
                  this.totalRefrow = {
                    batchReference: null,
                    transactionDate: null,
                    transactionType: "",
                    total: totalReference
                  };
                  this.AppendBankReferenceData(this.totalRefrow, tableName);
                }

                //add a new terminal
                prevTerminal = row.terminalNumber;
                prevDay = row.batchDate;

                tableName = "table" + count;
                this.CreateBankTransactionDataTable(tableName);
                this.AppendBankTransactionData(row, tableName);
                this.tableCreated = true;
              }

              if (count == (this.bankTransactionData.length)) {

                let totalReference: number = 0;
                this.tableCreated = false;
                for (var refBTTRow of this.bankTransactionReferenceTotal) {

                  var dd_ = String(refBTTRow.transactionDate.getDate()).padStart(2, '0');
                  var mm_ = String(refBTTRow.transactionDate.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var yyyy_ = refBTTRow.transactionDate.getFullYear();
                  let rowDate = mm_ + '/' + dd_ + '/' + yyyy_;


                  if (rowDate >= prevDayS) {
                    if (!this.tableCreated) {
                      tableName = "tableRef" + count;
                      this.CreateReferenceTotalTable(tableName);
                      this.tableCreated = true;
                    }
                    this.AppendBankReferenceData(refBTTRow, tableName);
                    totalReference += refBTTRow.total;
                  }
                }
                if (totalReference != 0) {
                  this.totalRefrow = {
                    batchReference: null,
                    transactionDate: null,
                    transactionType: "",
                    total: totalReference
                  };
                  this.AppendBankReferenceData(this.totalRefrow, tableName);
                }
              }

            }
          }
        }
      }
      else {
        this.raiseDanger = false;
        this.danger = "";

        this._ngxUiLoaderService.start();

        this.reportData = await this._reportService.GetBankReportData(this.startDate, this.endDate);

        if (this.reportData == null || this.reportData == undefined) {
          this.noData = "No data available.";
          this.raiseNoData = true;
          return;
        }

        if (this.reportData.bankTransaction.length <= 0) {
          this.noData = "No data available.";
          this.raiseNoData = true;
        }
        else {
          this.noData = "";
          this.raiseNoData = false;

          this.bankTransactionData = this.reportData.bankTransaction;
          //this.bankTransactionTotal = this.reportData.bankTransactionTotal;
          this.bankTransactionReferenceTotal = this.reportData.bankTransactionReferenceTotal;

          if (this.bankTransactionData.length > 0) {
            this.hasData = true;
          } else {
            this.hasData = false;
          }

          //REFERENCE: https://javascript.plainenglish.io/creating-a-dynamic-html-table-through-javascript-f554fba376cf
          this.ClearTable();
          var count: number = 0;

          var prevTerminal = "";
          var prevDay = new Date(1900, 1, 1);
          var prevDayS = "";
          var rowDate = "";

          var tableName = "";
          for (const row of this.bankTransactionData) {

            count++;

            if (count == 1) {
              prevTerminal = row.terminalNumber;
              prevDay = row.batchDate;
            }


            var dd = String(prevDay.getDate()).padStart(2, '0');
            var mm = String(prevDay.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = prevDay.getFullYear();
            prevDayS = mm + '/' + dd + '/' + yyyy;


            var dd_ = String(row.batchDate.getDate()).padStart(2, '0');
            var mm_ = String(row.batchDate.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy_ = row.batchDate.getFullYear();
            rowDate = mm_ + '/' + dd_ + '/' + yyyy_;


            if ((prevDayS == rowDate) && (prevTerminal == row.terminalNumber)) {
              //create table once since this terminal repeats.
              if (!this.tableCreated) {
                tableName = "table" + count;
                this.CreateBankTransactionDataTable(tableName);
                this.tableCreated = true;
              }
              this.AppendBankTransactionData(row, tableName);
            }
            else {
              this.tableCreated = false;

              var totalReference = 0;
              for (var refRow of this.bankTransactionReferenceTotal) {

                var dd = String(row.transactionTime.getDate()).padStart(2, '0');
                var mm = String(row.transactionTime.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = row.transactionTime.getFullYear();
                let prevDay_ = mm + '/' + dd + '/' + yyyy;

                var dd_ = String(refRow.transactionDate.getDate()).padStart(2, '0');
                var mm_ = String(refRow.transactionDate.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy_ = refRow.transactionDate.getFullYear();
                let rowDate_ = mm_ + '/' + dd_ + '/' + yyyy_;


                if (rowDate_ >= prevDayS && rowDate_ < prevDay_) {
                  if (!this.tableCreated) {
                    tableName = "tableRef" + count;
                    this.CreateReferenceTotalTable(tableName);
                    this.tableCreated = true;
                  }
                  this.AppendBankReferenceData(refRow, tableName);
                  totalReference += refRow.total;
                }
              }
              if (totalReference != 0) {
                this.totalRefrow = {
                  batchReference: null,
                  transactionDate: null,
                  transactionType: "",
                  total: totalReference
                };
                this.AppendBankReferenceData(this.totalRefrow, tableName);
              }

              //add a new terminal
              prevTerminal = row.terminalNumber;
              prevDay = row.batchDate;

              tableName = "table" + count;
              this.CreateBankTransactionDataTable(tableName);
              this.AppendBankTransactionData(row, tableName);
              this.tableCreated = true;
            }

            if (count == (this.bankTransactionData.length)) {

              let totalReference: number = 0;
              this.tableCreated = false;
              for (var refBTTRow of this.bankTransactionReferenceTotal) {

                var dd_ = String(refBTTRow.transactionDate.getDate()).padStart(2, '0');
                var mm_ = String(refBTTRow.transactionDate.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy_ = refBTTRow.transactionDate.getFullYear();
                let rowDate = mm_ + '/' + dd_ + '/' + yyyy_;


                if (rowDate >= prevDayS) {
                  if (!this.tableCreated) {
                    tableName = "tableRef" + count;
                    this.CreateReferenceTotalTable(tableName);
                    this.tableCreated = true;
                  }
                  this.AppendBankReferenceData(refBTTRow, tableName);
                  totalReference += refBTTRow.total;
                }
              }
              if (totalReference != 0) {
                this.totalRefrow = {
                  batchReference: null,
                  transactionDate: null,
                  transactionType: "",
                  total: totalReference
                };
                this.AppendBankReferenceData(this.totalRefrow, tableName);
              }
            }

          }
        }
      }

      this._ngxUiLoaderService.stop();
    }
  }

  public async reset(): Promise<void> {
    this._ngxUiLoaderService.start();

    this.reportData = null;
    this.ClearTable();

    this.hasData = false;
    this.tableCreated = false;
    this._ngxUiLoaderService.stop();

  }


  public async ClearTable(): Promise<void> {
    const bankTransDiv = document.querySelector("div.bankTransactions"); // Find the bankTransaction div in our HTML

    while (bankTransDiv.firstChild) {
      bankTransDiv.removeChild(bankTransDiv.firstChild); //Remove all children from table div (if any)
    }
  }

  public async CreateReferenceTotalTable(tableName: string): Promise<void> {

    const bankTransDiv = document.querySelector("div.bankTransactions"); // Find the bankTransaction div in our HTML

    let tableHeaders = ["Bank reference", "Transaction type", "Total"];

    /*while (bankTransDiv.firstChild) {
      bankTransDiv.removeChild(bankTransDiv.firstChild); //Remove all children from table div (if any)
    }*/

    let table = document.createElement("table");
    table.className = "table table-striped";
    table.id = tableName;// create the table it self
    table.style.width = "800px";
    let tableHeader = document.createElement("thead");// creates the table header group element
    let tableHeaderRow = document.createElement("tr");// create the row that will contain the headers
    tableHeaderRow.style.backgroundColor = "#348cd4";//#4fbde9
    tableHeaderRow.style.color = "white";

    //Will iterate over all the strings in the tableheader array and will append the header cells to the table header row
    tableHeaders.forEach(header => {
      let tableHeader = document.createElement("th");//
      tableHeader.innerHTML = "<b>" + header + "</b>";
      tableHeaderRow.append(tableHeader);
    });

    tableHeader.append(tableHeaderRow);
    table.append(tableHeader);

    let tableBody = document.createElement("tbody");
    table.append(tableBody);

    bankTransDiv.append(table);

  }

  public async CreateBankTransactionDataTable(tableName: string): Promise<void> {

    const bankTransDiv = document.querySelector("div.bankTransactions"); // Find the bankTransaction div in our HTML

    let tableHeaders = ["Reference", "Card number", "Date", "Transaction type", "Amount", "Terminal"];

    /*while (bankTransDiv.firstChild) {
      bankTransDiv.removeChild(bankTransDiv.firstChild); //Remove all children from table div (if any)
    }*/

    let table = document.createElement("table");
    table.className = "table table-striped";
    table.id = tableName;// create the table it self

    let tableHeader = document.createElement("thead");// creates the table header group element
    let tableHeaderRow = document.createElement("tr");// create the row that will contain the headers
    tableHeaderRow.style.backgroundColor = "#4fbde9";
    tableHeaderRow.style.color = "white";

    //Will iterate over all the strings in the tableheader array and will append the header cells to the table header row
    tableHeaders.forEach(header => {
      let tableHeader = document.createElement("th");//
      tableHeader.innerHTML = header;
      tableHeaderRow.append(tableHeader);
    });

    tableHeader.append(tableHeaderRow);
    table.append(tableHeader);

    let tableBody = document.createElement("tbody");
    table.append(tableBody);

    bankTransDiv.append(table);

  }

  public async AppendBankTransactionData(bankTransactionItem, table): Promise<void> {
    //Append data
    const bankTable = document.querySelector("#" + table) // Find the table we created
    let tableRow = document.createElement('tr') // Create the current table row
    // Lines 72-85 create the 5 column cells that will be appended to the current table row
    let transactionNr = document.createElement('td')
    transactionNr.innerText = bankTransactionItem.transactionNumber

    let panNumber = document.createElement('td')
    panNumber.innerText = bankTransactionItem.panNumber

    var dd_ = String(bankTransactionItem.transactionTime.getDate()).padStart(2, '0');
    var mm_ = String(bankTransactionItem.transactionTime.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy_ = bankTransactionItem.transactionTime.getFullYear();
    let date = yyyy_ + '/' + mm_ + '/' + dd_ + " " + (bankTransactionItem.transactionTime.getHours() - 2) + ":" + bankTransactionItem.transactionTime.getMinutes() + ":" + bankTransactionItem.transactionTime.getSeconds();

    let transactionTime = document.createElement('td')
    transactionTime.innerText = date

    let transactionType = document.createElement('td')
    transactionType.innerText = bankTransactionItem.transactionType

    let amount = document.createElement('td')
    amount.innerText = bankTransactionItem.amount

    let terminalNumber = document.createElement('td')
    terminalNumber.innerText = bankTransactionItem.terminalNumber

    tableRow.append(transactionNr, panNumber, transactionTime, transactionType, amount, terminalNumber) // Append all 5 cells to the table row
    bankTable.append(tableRow) // Append the current row to the scoreboard table body

  }

  public async AppendBankReferenceData(bankReferenceItem, table): Promise<void> {
    //Append data
    const bankTable = document.querySelector("#" + table) // Find the table we created
    let tableRow = document.createElement('tr') // Create the current table row
    // Lines 72-85 create the 5 column cells that will be appended to the current table row
    let bankReference = document.createElement('td')
    bankReference.innerText = bankReferenceItem.batchReference;

    let type = document.createElement('td')
    type.innerText = bankReferenceItem.transactionType;

    let total = document.createElement('td')
    total.innerText = bankReferenceItem.total.toFixed(2);

    tableRow.append(bankReference, type, total) // Append all 5 cells to the table row
    bankTable.append(tableRow) // Append the current row to the scoreboard table body

  }

  public async print(): Promise<void> {

    var printContent = document.getElementById("DIV_bankTransactions");
    var windowUrl = 'about:blank';
    var uniqueName = new Date();
    var windowName = 'Print' + uniqueName.getTime();
    var printWindow = window.open(windowUrl, windowName, 'left=50000,top=50000,width=0,height=0');

    printWindow.document.write(printContent.innerHTML);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  }

  public async exportToExel(): Promise<void> {

    this.tableCreated = false;
    var count: number = 0;

    var prevTerminal = "";
    var prevDay = new Date(1900, 1, 1);
    var prevDayS = "";
    var rowDate = "";

    var tableName = "";
    for (const row of this.bankTransactionData) {

      count++;

      if (count == 1) {
        prevTerminal = row.terminalNumber;
        prevDay = row.batchDate;
      }


      var dd = String(prevDay.getDate()).padStart(2, '0');
      var mm = String(prevDay.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = prevDay.getFullYear();
      prevDayS = mm + '/' + dd + '/' + yyyy;


      var dd_ = String(row.batchDate.getDate()).padStart(2, '0');
      var mm_ = String(row.batchDate.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy_ = row.batchDate.getFullYear();
      rowDate = mm_ + '/' + dd_ + '/' + yyyy_;


      if ((prevDayS == rowDate) && (prevTerminal == row.terminalNumber)) {
        //create table once since this terminal repeats.
        if (!this.tableCreated) {
          tableName = "table" + count;
          this.CreateBankTransactionDataTableForXlsx(tableName);
          this.tableCreated = true;
        }
        this.AppendBankTransactionDataForXlsx(row, tableName);
      }
      else {
        this.tableCreated = false;

        var totalReference = 0;
        for (var refRow of this.bankTransactionReferenceTotal) {

          var dd = String(row.transactionTime.getDate()).padStart(2, '0');
          var mm = String(row.transactionTime.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy = row.transactionTime.getFullYear();
          let prevDay_ = mm + '/' + dd + '/' + yyyy;

          var dd_ = String(refRow.transactionDate.getDate()).padStart(2, '0');
          var mm_ = String(refRow.transactionDate.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy_ = refRow.transactionDate.getFullYear();
          let rowDate_ = mm_ + '/' + dd_ + '/' + yyyy_;


          if (rowDate_ >= prevDayS && rowDate_ < prevDay_) {
            if (!this.tableCreated) {
              tableName = "tableRef" + count;
              this.CreateReferenceTotalTableForXlsx(tableName);
              this.tableCreated = true;
            }
            this.AppendBankReferenceDataForXlsx(refRow, tableName);
            totalReference += refRow.total;
          }
        }
        if (totalReference != 0) {
          this.totalRefrow = {
            batchReference: null,
            transactionDate: null,
            transactionType: "",
            total: totalReference
          };
          this.AppendBankReferenceDataForXlsx(this.totalRefrow, tableName);
        }

        //add a new terminal
        prevTerminal = row.terminalNumber;
        prevDay = row.batchDate;

        tableName = "table" + count;
        this.CreateBankTransactionDataTableForXlsx(tableName);
        this.AppendBankTransactionDataForXlsx(row, tableName);
        this.tableCreated = true;
      }

      if (count == (this.bankTransactionData.length)) {

        let totalReference: number = 0;
        this.tableCreated = false;
        for (var refBTTRow of this.bankTransactionReferenceTotal) {

          var dd_ = String(refBTTRow.transactionDate.getDate()).padStart(2, '0');
          var mm_ = String(refBTTRow.transactionDate.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy_ = refBTTRow.transactionDate.getFullYear();
          let rowDate = mm_ + '/' + dd_ + '/' + yyyy_;


          if (rowDate >= prevDayS) {
            if (!this.tableCreated) {
              tableName = "tableRef" + count;
              this.CreateReferenceTotalTableForXlsx(tableName);
              this.tableCreated = true;
            }
            this.AppendBankReferenceDataForXlsx(refBTTRow, tableName);
            totalReference += refBTTRow.total;
          }
        }
        if (totalReference != 0) {
          this.totalRefrow = {
            batchReference: null,
            transactionDate: null,
            transactionType: "",
            total: totalReference
          };
          this.AppendBankReferenceDataForXlsx(this.totalRefrow, tableName);
        }
      }
    }


    var fileName = 'BankReport_' + this.startDate + '_' + this.endDate;
    this._reportService.exportJsonToExcel(this.edata, fileName);


  }

  public async exportToCSV(): Promise<void> {

    const data = this.bankTransactionData;
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here

    const headerRow = {
      Reference: '',
      CardNumber: '',
      Date: '',
      TransactionType: '',
      Amount: '',
      Terminal: ''
    }

    const header = Object.keys(headerRow);

    const data1 = data.map(element => ({ Reference: element.transactionNumber, CardNumber: element.panNumber, Date: element.transactionTime, TransactionType: element.transactionType, Amount: element.amount, Terminal: element.terminalNumber }))

    const csv = data1.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );


    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    var fileName = 'BankReport_' + this.startDate + '_' + this.endDate + '_.csv';
    a.href = url;
    a.download = (fileName);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }


  //For XLSX Report
  public async CreateReferenceTotalTableForXlsx(tableName: string): Promise<void> {

    const udt: ExcelJson = {
      data: [
        { A: '' },
        { A: 'Bank reference', B: 'Transaction type', C: 'Total' }//table headers
      ],
      skipHeader: true
    };

    this.edata.push(udt);

  }

  public async CreateBankTransactionDataTableForXlsx(tableName: string): Promise<void> {
    const udt: ExcelJson = {
      data: [
        { A: '' },
        { A: 'Reference', B: 'Card number', C: 'Date', D: 'Transaction type', E: 'Amount', F: 'Terminal' }, //table headers
      ],
      skipHeader: true
    };

    this.edata.push(udt);

  }

  public async AppendBankTransactionDataForXlsx(bankTransactionItem, table): Promise<void> {
    //Append data
    var dd_ = String(bankTransactionItem.transactionTime.getDate()).padStart(2, '0');
    var mm_ = String(bankTransactionItem.transactionTime.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy_ = bankTransactionItem.transactionTime.getFullYear();
    let date = yyyy_ + '/' + mm_ + '/' + dd_ + " " + (bankTransactionItem.transactionTime.getHours() - 2) + ":" + bankTransactionItem.transactionTime.getMinutes() + ":" + bankTransactionItem.transactionTime.getSeconds();

    const udt: ExcelJson = {
      data: [
        {
          A: bankTransactionItem.transactionNumber,
          B: bankTransactionItem.panNumber,
          C: '' + date,
          D: bankTransactionItem.transactionType,
          E: bankTransactionItem.amount,
          F: bankTransactionItem.terminalNumber
        }// table header
      ],
      skipHeader: true
    };
    this.edata.push(udt);
  }

  public async AppendBankReferenceDataForXlsx(bankReferenceItem, table): Promise<void> {

    const udt: ExcelJson = {
      data: [
        {
          A: bankReferenceItem.batchReference,
          B: bankReferenceItem.transactionType,
          C: bankReferenceItem.total.toFixed(2)
        }// table header
      ],
      skipHeader: true
    };
    this.edata.push(udt);

  }


}
